import SettingsExpertTeamDetailsComponent from './team-details.component'

const SettingsExpertTeamDetailsModule = angular.module('cdbl.team-details', [

])
  .component('cdblSettingsExpertTeamDetails', SettingsExpertTeamDetailsComponent)
  .name

export default SettingsExpertTeamDetailsModule
